import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { MembershipDiscounts } from 'model/membership-discounts';
import { MembershipPrice } from 'model/membershipPrice';

@Injectable()
export class MembershipService {
    deleted: number[] = [];
    
    constructor(private api: ApiService) {

    }
    
    getMembershipDiscounts(membershipId: number) : Promise<MembershipDiscounts[]> {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth<MembershipDiscounts[]>(this.api.endpoints.memberships + '/GetMembershipDiscounts?membershipId=' + membershipId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getMembershipPrices(membershipId: number): Promise<MembershipPrice[]> {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth<MembershipPrice[]>(this.api.endpoints.memberships + '/GetMembershipPrices?membershipId=' + membershipId)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/membership.service.ts